import React, { useState, useEffect } from "react";
import {
  Box, Typography, TextField, Button, Radio, RadioGroup,
  FormControlLabel, FormLabel, FormControl
} from "@mui/material";
import { useAuth } from "../../auth/AuthContext";
import LoadingPage from "../../Loader";
import { useNavigate, useLocation } from "react-router-dom";
import primaryBackground from "../../assets/Backgrounds/primaryBg.svg";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState('student');
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const { setLogin,  userRole, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      const intendedPath = location.state?.from?.pathname || 
                          (userRole === 'parent' ? '/student/portal' : '/student/portal');
      navigate(intendedPath, { replace: true });
    }
  }, [isAuthenticated, userRole, location, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) 
      newErrors.email = 'Valid email is required';
    if (formData.password.length < 8) 
      newErrors.password = 'Password must be at least 8 characters';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async () => {
    if (!validate()) return;

    setLoading(true);
    try {
      const response = await setLogin('proccess.php', { 
        email: formData.email, 
        password: formData.password, 
        type: userType 
      });
      if (response.success) {
        // Store auth status and user details in localStorage
      
        localStorage.setItem('authStatus', JSON.stringify({
          isLoggedIn: true,
          user: {
            id: response.data.userID,
            email: formData.email,
            type: response.data.userRole
          }
        }));
      } else {
        //console.log(response);
        
        alert(response.message || 'Login failed');
      }
    } catch (error) {
      alert(`Login error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingPage />;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${primaryBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        p: 3,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 500,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 3,
          p: 4,
        }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          Login
        </Typography>

        <FormControl component="fieldset" sx={{ mb: 3 }}>
          <FormLabel component="legend">Login as:</FormLabel>
          <RadioGroup
            name="userType"
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
          >
            <FormControlLabel value="student" control={<Radio />} label="Student" />
            <FormControlLabel value="parent" control={<Radio />} label="Parent" />
          </RadioGroup>
        </FormControl>

        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          margin="normal"
          error={!!errors.email}
          helperText={errors.email}
        />
        <TextField
          fullWidth
          label="Password"
          name="password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          margin="normal"
          error={!!errors.password}
          helperText={errors.password}
        />

        <Button
          fullWidth
          variant="contained"
          onClick={handleLogin}
          sx={{ mt: 2 }}
        >
          Login
        </Button>
      </Box>
    </Box>
  );
};

export default Login;